import './ScrapInfo.css';

export function ScrapInfo() {
  return (
    <section id="sloopgoud" className="scrap-info">
      <div className="scrap-info__container">
        <div className="scrap-info__content">
          <h2 className="scrap-info__title">
            Aankoop van sloopgoud en zilver aan hoge netto prijzen
          </h2>

          <p className="scrap-info__text">
            Wilt u uw oud goud, zilver of munten verkopen? Hier vindt u dagelijks onze actuele
            inkoopprijzen voor de inkoop van sloopgoud en zilver. Wat u ziet in de tabel is wat wij
            minimum netto betalen in euro per gram volgens gehalte en gewicht. Wij betalen meer voor
            recente her-verkoopbare juwelen met grotere diamanten in goede staat met bij voorkeur de
            nodige documenten. Deze worden geschat volgens goud en diamant waarde. Zeer kleine
            diamantjes gezet in juwelen hebben weinig of geen meerwaarde. Ook met tandengoud kan u
            bij ons terecht.
          </p>

          <p className="scrap-info__text">
            Onze inkoopprijzen worden dagelijks meermaals aangepast, zo weet u altijd waar u aan toe
            bent.
          </p>

          <p className="scrap-info__text">
            U kan bij ons doorlopend terecht tijdens de kantooruren voor advies over de verkoop van
            uw goud, juwelen, gouden en zilveren munten en diamanten. Wij doen taxaties van uw
            goud/diamant bij voorkeur na afspraak.
          </p>

          <p className="scrap-info__highlight">
            Al het sloopgoud wordt in onze eigen goudsmelterij verwerkt waardoor wij u hoge netto
            prijzen kunnen uitbetalen.
          </p>
        </div>
      </div>
    </section>
  );
}
